export default __webpack_public_path__ + "static/media/finkeljoins.b230702f.jpg";